import React, { useEffect, useState, useRef } from "react";
import "../../assets/css/Services.css";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

// meta data
import { Helmet } from "react-helmet";
import data from "../../component/ApiUrl/meta_api";

/* ─── Data ─────────────────────────────────────────────────────────────────── */
const SERVICES = [
  {
    icon: "fa-magnifying-glass-chart",
    title: "Search Engine Optimization (SEO)",
    desc: "Improve your website visibility on Google with advanced SEO strategies including keyword research, on-page optimization, technical SEO, and high-quality content marketing. Skimitar Hindustan Pvt Ltd helps businesses rank higher in search results, attract organic traffic, and generate consistent leads.",
  },
  {
    icon: "fa-bullhorn",
    title: "Paid Advertising (Google & Social Ads)",
    desc: "Drive instant traffic and qualified leads with high-performance paid advertising campaigns. We create and manage ROI-focused campaigns across Google Ads, Facebook Ads, Instagram Ads, and LinkedIn Ads to maximize conversions and reduce cost-per-lead.",
  },
  {
    icon: "fa-robot",
    title: "AI-Powered Marketing",
    desc: "Leverage artificial intelligence to enhance marketing performance. Our AI-powered tools analyze customer behavior, predict trends, optimize campaigns, and automate targeting strategies to deliver smarter and more effective digital marketing results.",
  },
  {
    icon: "fa-hashtag",
    title: "Social Media Marketing",
    desc: "Build brand awareness and connect with your audience through strategic social media marketing. We create engaging content, manage campaigns, and grow your presence on platforms like Instagram, Facebook, LinkedIn, and YouTube.",
  },
  {
    icon: "fa-envelope-open-text",
    title: "Email Marketing & Lead Nurturing",
    desc: "Convert prospects into loyal customers with targeted email marketing campaigns. Our automated email strategies help nurture leads, improve engagement, and increase conversion rates through personalized communication.",
  },
  {
    icon: "fa-gears",
    title: "Marketing Automation",
    desc: "Automate repetitive marketing tasks such as email campaigns, lead tracking, analytics, and customer segmentation. Our marketing automation solutions improve efficiency, enhance customer journeys, and accelerate business growth.",
  },
];

const TABS = [
  {
    tabs: "SEO Marketing",
    label: "SEO & Content Marketing",
    icon: "fa-magnifying-glass-chart",
    image: require("../../assets/img/Service/digital marketing/card-1.jpg"),
    content:
      "Boost your online visibility and drive organic traffic with our data-driven SEO strategies and compelling content — crafted to rank higher and engage your target audience effectively.",
    features: [
      "On-Page & Off-Page SEO",
      "Keyword Research & Strategy",
      "Blog, Article & Copywriting",
      "Technical SEO & Link Building",
    ],
  },

  {
    tabs: "Social Media Marketing",
    label: "Social Media Marketing",
    icon: "fa-hashtag",
    image: require("../../assets/img/Service/digital marketing/card-2.jpg"),
    content:
      "Build a powerful brand presence across all major social platforms with our strategic social media management — from content creation to community engagement and growth campaigns.",
    features: [
      "Social Media Strategy & Planning",
      "Instagram, Facebook & LinkedIn",
      "Content Creation & Scheduling",
      "Influencer & Community Management",
    ],
  },

  {
    tabs: "Paid & PPC Campaigns",
    label: "Paid Ads & PPC Campaigns",
    icon: "fa-bullhorn",
    image: require("../../assets/img/Service/digital marketing/card-3.jpg"),
    content:
      "Maximize your return on investment with our performance-driven paid advertising campaigns — precisely targeted to reach the right audience at the right time across all digital platforms.",
    features: [
      "Google Ads & Search Campaigns",
      "Meta & Instagram Ads",
      "Retargeting & Remarketing",
      "Budget & Bid Optimization",
    ],
  },

  {
    tabs: "Design & Video Production",
    label: "Branding, Design & Video Production",
    icon: "fa-photo-film",
    image: require("../../assets/img/Service/digital marketing/card-4.jpg"),
    content:
      "Create a lasting brand impression with our creative design and video production services — from powerful brand identities to engaging reels, ads, and corporate videos that tell your story.",
    features: [
      "Brand Identity & Logo Design",
      "Reels, Videos & Motion Graphics",
      "Marketing Collateral Design",
      "Brand Strategy & Storytelling",
    ],
  },

  {
    tabs: "Website & Development",
    label: "Website Design & Development",
    icon: "fa-code",
    image: require("../../assets/img/Service/digital marketing/card-5.jpg"),
    content:
      "Launch a professional, high-converting website that represents your brand with impact — built with modern design, fast performance, and optimized for both search engines and users.",
    features: [
      "Business & E-Commerce Websites",
      "Landing Page Development",
      "UI/UX Design & Prototyping",
      "Website Speed & SEO Optimization",
    ],
  },

  {
    tabs: "Email & Performance Reporting",
    label: "Analytics, Email & Performance Reporting",
    icon: "fa-chart-line",
    image: require("../../assets/img/Service/digital marketing/card-6.jpg"),
    content:
      "Make smarter marketing decisions with our data-driven analytics, email automation, and detailed performance reporting — turning numbers into clear strategies for continuous growth.",
    features: [
      "Google Analytics & Tag Setup",
      "Email Campaigns & Automation",
      "Conversion Rate Optimization",
      "Monthly ROI & Campaign Reports",
    ],
  },
];

const STEPS = [
  {
    icon: "fa-magnifying-glass",
    title: "Market & Website Audit",
    desc: "Analyze website, competitors, audience, and identify SEO growth opportunities.",
  },
  {
    icon: "fa-lightbulb",
    title: "Strategy & Campaign Planning",
    desc: "Create data-driven marketing strategy aligned with business goals.",
  },
  {
    icon: "fa-gears",
    title: "Implementation & Optimization",
    desc: "Execute campaigns, improve SEO, ads, and optimize marketing performance.",
  },
  {
    icon: "fa-chart-line",
    title: "Performance Tracking & Analytics",
    desc: "Track traffic, rankings, conversions, and campaign performance with analytics.",
  },
  {
    icon: "fa-rocket",
    title: "Growth & Continuous Improvement",
    desc: "Scale campaigns, refine strategy, and drive long-term digital growth.",
  },
];

const BENEFITS = [
  {
    icon: "fa-magnifying-glass-chart",
    title: "SEO Services",
    desc: "Keyword Research · On-Page SEO · Technical SEO · Link Building · Google Ranking",
  },
  {
    icon: "fa-bullhorn",
    title: "Google Ads (PPC)",
    desc: "Search Ads · Display Ads · Lead Generation · ROI Optimization · Paid Campaigns",
  },
  {
    icon: "fa-thumbs-up",
    title: "Social Media Marketing",
    desc: "Instagram Marketing · Facebook Ads · Content Creation · Brand Awareness · Engagement",
  },
  {
    icon: "fa-chart-line",
    title: "Performance Marketing",
    desc: "Data-Driven Strategy · Conversion Optimization · ROI Focus · Analytics & Tracking",
  },
  {
    icon: "fa-users",
    title: "Lead Generation",
    desc: "High-Quality Leads · Sales Funnel · Landing Pages · Conversion Optimization",
  },
  {
    icon: "fa-robot",
    title: "Marketing Automation",
    desc: "Email Marketing · CRM Integration · Automation Tools · Customer Journey Optimization",
  },
];

const FAQ_DATA = [
  [
    "What Digital Marketing services do you offer?",
    "We provide complete Digital Marketing Services including SEO (Search Engine Optimization), Google Ads (PPC), Social Media Marketing, Content Marketing, Lead Generation, and Marketing Automation to grow your business online.",
  ],
  [
    "How can Digital Marketing help my business grow?",
    "Digital Marketing helps increase your online visibility, drive targeted traffic, generate quality leads, and improve conversions using SEO, paid ads, and social media strategies.",
  ],
  [
    "Do you provide SEO services for websites?",
    "Yes, we offer professional SEO services including keyword research, on-page SEO, technical SEO, and link building to improve your Google rankings and organic traffic.",
  ],
  [
    "What is included in your Google Ads service?",
    "Our Google Ads (PPC) service includes campaign setup, keyword targeting, ad copy creation, A/B testing, and continuous optimization to maximize ROI and reduce cost per lead.",
  ],
  [
    "Do you manage social media marketing?",
    "Yes, we handle complete Social Media Marketing including content creation, post scheduling, ad campaigns, audience targeting, and engagement strategies for platforms like Instagram, Facebook, and LinkedIn.",
  ],
  [
    "How long does it take to see results from Digital Marketing?",
    "SEO typically takes 3–6 months for visible results, while Google Ads and Social Media Ads can generate leads within days. We focus on both short-term and long-term growth strategies.",
  ],
  [
    "Do you provide lead generation services?",
    "Yes, we specialize in lead generation using SEO, Google Ads, landing pages, and funnel optimization to bring high-quality leads for your business.",
  ],
  [
    "How much do Digital Marketing services cost?",
    "The cost depends on your business goals, competition, and services required. We offer flexible and affordable Digital Marketing packages tailored to your needs.",
  ],
  [
    "Will I get reports and performance tracking?",
    "Yes, we provide regular reports including website traffic, keyword rankings, ad performance, and lead conversions with detailed analytics.",
  ],
  [
    "How can I get started with your Digital Marketing services?",
    "You can contact us for a free consultation. We will analyze your business, understand your goals, and provide a customized Digital Marketing strategy and proposal.",
  ],
];

/* ─── Small components ──────────────────────────────────────────────────────── */
function SectionLabel({ text }) {
  return (
    <p
      className="fw-semibold text-uppercase mb-1"
      style={{ fontSize: 20, color: "#cc0000", letterSpacing: 1 }}
    >
      {text}
    </p>
  );
}

function FAQItem({ q, a, idx }) {
  const [open, setOpen] = useState(idx === 0);
  return (
    <div
      className={`rs-faq-item rs-anim${open ? " open" : ""}`}
      style={{ transitionDelay: `${idx * 55}ms` }}
    >
      <button className="rs-faq-btn" onClick={() => setOpen((o) => !o)}>
        <span className="rs-faq-q">{q}</span>
        <span className="rs-faq-icon">
          <i className="fa-solid fa-plus" />
        </span>
      </button>
      <div className="rs-faq-body">{a}</div>
    </div>
  );
}

/* ─── Main Page ─────────────────────────────────────────────────────────────── */
export default function DigitalMarketing() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const DigitalMarketingMeta = data[0]?.digitalmarketing_page;
    if (DigitalMarketingMeta) {
      setMeta(DigitalMarketingMeta);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-in-out",
    });

    if (!document.getElementById("rs-styles")) {
      const s = document.createElement("style");
      s.id = "rs-styles";
      document.head.appendChild(s);
    }
    if (!document.querySelector('link[href*="font-awesome"]')) {
      const fa = document.createElement("link");
      fa.rel = "stylesheet";
      fa.href =
        "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css";
      document.head.appendChild(fa);
    }
    if (!document.querySelector('link[href*="Poppins"]')) {
      const gf = document.createElement("link");
      gf.rel = "stylesheet";
      gf.href =
        "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap";
      document.head.appendChild(gf);
    }
  }, []);

  const tab = TABS[activeTab];

  return (
    <div className="body">
      <Helmet>
        <title>{meta ? meta.title : "Digital Marketing"}</title>
      </Helmet>

      {/* ═════════
          1. HERO 
      ═════════════ */}
      <div
        className="backgroundCommenImage position-relative d-flex align-items-center mb-5"
        style={{
          backgroundImage: `url(${require("../../assets/img/Service/digital marketing/DM-SERVICE_page.jpg")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "60vh",
        }}
      >
        {/* Overlay */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ background: "rgba(0, 0, 0, 0.8)", zIndex: 1 }}
        ></div>

        {/* Content */}
        <div
          className="container position-relative text-center text-white py-4 py-md-5"
          style={{ zIndex: 2 }}
        >
          {/* Badge */}
          <span
            className="fw-semibold d-inline-block mb-3 px-3 py-1 rounded-pill"
            style={{
              background: "#cc0000",
              fontSize: "clamp(10px,3vw,12px)",
              letterSpacing: "0.5px",
            }}
            data-aos="fade-down"
            data-aos-delay="100"
          >
            ✦ AI-Powered · Results-Driven · {new Date().getFullYear()} Certified
          </span>

          {/* Heading */}
          <h1
            className="fw-semibold mb-3"
            style={{
              fontSize: "clamp(18px,5vw,28px)",
              lineHeight: 1.4,
            }}
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Digital Marketing
            <br />
            <span style={{ color: "#cc0000" }}>
              SEO · Ads · AI · Social · Automation
            </span>
          </h1>

          {/* Text */}
          <p
            className="mx-auto mb-4 px-2 px-md-0"
            style={{
              fontSize: "clamp(13px,3.5vw,15px)",
              maxWidth: "650px",
              lineHeight: 1.7,
              color: "#ebe6e6",
            }}
            data-aos="fade-up"
            data-aos-delay="350"
          >
            From your first Google Ad to running full-funnel AI-powered
            campaigns — Skimitar Hindusthan delivers India's most
            results-driven, hands-on Digital Marketing training. Real campaigns.
            Real data. Real growth.
          </p>
        </div>
      </div>

      {/* ════════════
          2. INTRO — 
      ═════════════════ */}
      <div className="container margin_top container_width">
        <div className="row align-items-center justify-content-center g-5">
          {/* Left */}
          <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
            <SectionLabel text="Digital Marketing Services" />

            <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
              About Our Digital Marketing Services
            </h2>

            <p className="mb-3" style={{ fontSize: 15 }}>
              <span className="fw-semibold">Skimitar Hindustan Pvt Ltd</span>{" "}
              delivers results-driven Digital Marketing solutions designed to
              help businesses grow faster in today's competitive online
              landscape. Our strategies combine Search Engine Optimization
              (SEO), Paid Advertising, Artificial Intelligence (AI), Social
              Media Marketing, and Marketing Automation to create measurable
              growth and consistent lead generation.
            </p>

            <p className="mb-3" style={{ fontSize: 15 }}>
              In a digital-first world, simply having a website is not enough.
              Businesses need powerful data-driven marketing strategies to
              increase visibility, attract the right audience, and convert
              visitors into loyal customers.
            </p>

            <ul className="list-unstyled mt-3">
              {[
                "Increase website traffic and search engine visibility",
                "Generate high-quality leads and improve conversion rates",
                "Reduce marketing costs with targeted campaigns",
                "Strengthen brand authority across digital platforms",
                "Utilize AI-driven insights for smarter marketing decisions",
                "Automate marketing workflows for faster business growth",
              ].map((item, i) => (
                <li
                  key={i}
                  className="d-flex align-items-start gap-2 mb-2 small"
                  data-aos="fade-up"
                  data-aos-delay={`${100 + i * 80}`}
                >
                  <i className="fa-solid fa-check text-danger mt-1"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right */}
          <div
            className="col-lg-6 text-center"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <div className="position-relative d-inline-block w-100">
              {/* Image */}
              <img
                className="img-fluid rounded-4 "
                src={require("../../assets/img/Service/digital marketing/dm-1.jpg")}
                alt="DM Image-1"
              />

              {/* Stat */}
              <div className="retro-stat">
                <i className="fa-solid fa-rotate text-danger fs-5"></i>
                <div>
                  <div className="fw-bold fs-5">350+</div>
                  <div className="small text-muted">Digital Marketing</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════
          3. OUR SERVICES
      ════════════════════ */}
      <section className="margin_top py-5 bg-light">
        <div className="container container_width">
          <div className="mb-2" data-aos="fade-up">
            <SectionLabel text="Our Digital Marketing Services" />
          </div>

          <div className="row align-items-center mb-5">
            <div
              className="col-lg-6"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <h2 className="fw-semibold" style={{ fontSize: 20 }}>
                Comprehensive Digital Marketing Solutions
              </h2>

              <p className="mb-3" style={{ fontSize: 15 }}>
                From improving search engine rankings to managing
                high-performance advertising campaigns, we handle every aspect
                of modern digital marketing to ensure your brand reaches the
                right audience at the right time.
              </p>
            </div>

            <div
              className="col-lg-6 text-lg-end mt-3 mt-lg-0"
              data-aos="fade-left"
              data-aos-delay="100"
            >
              <a href="#contact" className="btn btn-danger px-4 py-2">
                Discuss Your Project
                <i className="fa-solid fa-arrow-right ms-2"></i>
              </a>
            </div>
          </div>

          {/* Cards */}
          <div className="row g-3">
            {SERVICES.map((s, i) => (
              <div
                key={i}
                className="col-12 col-sm-6 col-lg-4"
                data-aos="fade-up"
                data-aos-delay={`${i * 100}`}
              >
                <div className="card h-100 border-0 shadow service-card">
                  <div className="card-body position-relative p-4">
                    {/* Number */}
                    <span className="service-number">
                      {String(i + 1).padStart(2, "0")}
                    </span>

                    {/* Icon */}
                    <div className="service-icon mb-3">
                      <i className={`fa-solid ${s.icon}`}></i>
                    </div>

                    <h5 className="fw-bold mb-2" style={{ fontSize: 15 }}>
                      {s.title}
                    </h5>

                    <p className="small text-muted mb-0">{s.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════
          4. SERVICE DETAILS — tabs + feature list
      ══════════════════════════════════════════════════════════════ */}
      <section className="margin_top pb-5">
        <div className="container container_width">
          <div className="mb-1" data-aos="fade-up">
            <SectionLabel text="Digital Marketing Service Details" />
          </div>

          <div className="row mb-4">
            <div className="col-lg-7" data-aos="fade-up" data-aos-delay="100">
              <h2 className="fw-semibold mb-2" style={{ fontSize: 20 }}>
                What Each Digital Marketing Service Delivers
              </h2>

              <p className="mb-3" style={{ fontSize: 15 }}>
                With{" "}
                <span className="fw-semibold">Skimitar Hindustan Pvt Ltd</span>,
                you gain access to a dedicated digital marketing team that
                combines creativity, technology, and performance analytics to
                deliver impactful results in the modern digital landscape.
              </p>
            </div>
          </div>

          {/* Tabs */}
          <div
            className="d-flex justify-content-center flex-wrap gap-2 mb-5"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            {TABS.map((t, i) => (
              <button
                key={i}
                className={`btn btn-sm rounded-4 ${
                  activeTab === i ? "btn-danger" : "btn-outline-secondary"
                }`}
                onClick={() => setActiveTab(i)}
              >
                <i className={`fa-solid ${t.icon} me-2`} />
                {t.tabs}
              </button>
            ))}
          </div>

          {/* Content */}
          <div className="row align-items-center g-5">
            {/* Image */}
            <div
              className="col-lg-5 justify-content-center"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <img
                src={tab.image}
                alt={tab.label}
                className="img-fluid rounded-4"
              />
            </div>

            {/* Text Content */}
            <div className="col-lg-7" data-aos="fade-left" data-aos-delay="200">
              <SectionLabel text={tab.label} />

              <p className="mb-3" style={{ fontSize: 15 }}>
                {tab.content}
              </p>

              {/* Features */}
              <div>
                {tab.features.map((f, i) => (
                  <div
                    key={i}
                    className="d-flex align-items-start border-bottom py-3"
                    data-aos="fade-up"
                    data-aos-delay={`${i * 80}`}
                  >
                    <div className="feature-dot me-3">
                      <i className="fa-solid fa-check"></i>
                    </div>

                    <span className="fw-medium small">{f}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════
          5. HOW IT WORKS — 5-step process
      ══════════════════════════════════════════════════════════════ */}
      <section className="margin_top py-5 bg-light" id="process">
        <div className="container container_width">
          <div className="mb-2" data-aos="fade-up">
            <SectionLabel text="How Our Digital Marketing Strategy Works" />
          </div>

          <div className="mb-5" data-aos="fade-up" data-aos-delay="100">
            <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
              Our 5-Step Digital Marketing Process
            </h2>
            <p className="mb-3" style={{ fontSize: 15 }}>
              Our approach focuses on research, strategy, implementation,
              optimization, and continuous performance improvement. By combining
              advanced marketing tools with industry expertise, we help
              businesses attract the right audience, increase online visibility,
              and generate high-quality leads.
            </p>
          </div>

          <div className="row g-4 text-center justify-content-center">
            {STEPS.map((step, i) => (
              <div
                key={i}
                className="col-6 col-md-4 col-lg position-relative"
                data-aos="fade-up"
                data-aos-delay={`${i * 120}`}
              >
                {/* connector */}
                {i < STEPS.length - 1 && (
                  <div className="process-line d-none d-lg-block"></div>
                )}

                {/* circle */}
                <div className="process-circle mx-auto mb-3 d-flex align-items-center justify-content-center position-relative">
                  <i className={`fa-solid ${step.icon} text-red fs-5`}></i>

                  <span className="badge bg-red position-absolute process-number">
                    {i + 1}
                  </span>
                </div>

                <h5 className="fw-bold small mb-1">{step.title}</h5>

                <p className="text-muted small mb-0">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════
          6. WHY CHOOSE US — left content + right grid
      ══════════════════════════════════════════════════════════════ */}
      <section className="margin_top pb-5" id="why">
        <div className="container container_width">
          <div className="row align-items-start g-5 justify-content-center">
            {/* Left */}
            <div
              className="col-lg-5 rs-anim-l"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <SectionLabel text="Why Choose Us" />
              <h2 className="fw-semibold mb-3" style={{ fontSize: 22 }}>
                The Digital Marketing Advantage
              </h2>

              <p className="mb-3" style={{ fontSize: 15 }}>
                5+ Years Experience · Digital Marketing Services · SEO · Google
                Ads · Social Media Marketing · Lead Generation · ROI-Driven
                Strategies · Business Growth · Performance Marketing
              </p>
              <div className="rs-quote-box">
                <p>
                  "Our business saw a massive increase in website traffic and
                  lead generation after working with this team. Their expertise
                  in SEO, Google Ads, and social media marketing delivered
                  measurable results and improved our ROI significantly within
                  months."
                </p>
                <span>— Business Owner, E-commerce Brand, Tamil Nadu</span>
              </div>
            </div>

            {/* Right */}
            <div className="col-lg-7">
              <div className="row g-3">
                {BENEFITS.map((b, i) => (
                  <div
                    key={i}
                    className="col-12 col-sm-6 rs-anim"
                    style={{ transitionDelay: `${i * 80}ms` }}
                    data-aos="fade-up"
                    data-aos-delay={`${i * 100}`}
                  >
                    <div className="rs-benefit-item">
                      <div className="rs-icon-box">
                        <i className={`fa-solid ${b.icon}`} />
                      </div>
                      <div>
                        <div className="rs-benefit-title">{b.title}</div>
                        <div className="rs-benefit-desc">{b.desc}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════
          7. FAQ
      ══════════════════════════════════════════════════════════════ */}
      <section className="margin_top pb-5 rs-bg-alt" id="faq">
        <div className="container container_width py-5">
          <div className="text-center rs-anim mb-1" data-aos="fade-up">
            <SectionLabel text="FAQ" />
          </div>
          <div
            className="text-center rs-anim mb-5"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <h2 className="fw-semibold" style={{ fontSize: 20 }}>
              Frequently Asked Questions
            </h2>
            <p className="mb-3" style={{ fontSize: 15 }}>
              Everything you need to know about our Digital Marketing Services
              including SEO, Google Ads, Social Media Marketing, Lead
              Generation, and ROI-driven strategies.
            </p>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-9">
              {FAQ_DATA.map(([q, a], i) => (
                <FAQItem key={i} q={q} a={a} idx={i} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════
          8. GET IN TOUCH — CTA
      ══════════════════════════════════════════════════════════════ */}
      <section style={{ marginTop: "100px" }}>
        <div className="p-5" style={{ background: "#cc0000" }}>
          <div
            className="d-flex align-items-center justify-content-center gap-3 mb-3"
            data-aos="fade-down"
          >
            <div
              className="bg-light"
              style={{ width: "40px", height: "1px" }}
            />
            <span
              className="text-uppercase fw-semibold text-white text-opacity-75"
              style={{
                letterSpacing: "2px",
                whiteSpace: "nowrap",
                fontSize: "13px",
              }}
            >
              Grow Your Business Online
            </span>
            <div
              className="bg-light"
              style={{ width: "40px", height: "1px" }}
            />
          </div>

          <div className="row g-4 align-items-center">
            <div
              className="col-lg-7 text-center text-lg-start"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <h2 className="fw-bolder text-white text-uppercase mb-3">
                Boost Your Business with <br />
                Digital Marketing Experts
              </h2>

              <p
                className="text-white text-opacity-75 mb-0"
                style={{ lineHeight: "1.75" }}
              >
                Drive more traffic, generate high-quality leads, and increase
                your sales with our expert Digital Marketing services. From SEO
                and Google Ads to Social Media Marketing and Performance
                Marketing, we help your business grow faster with data-driven
                strategies and measurable results.
              </p>
            </div>

            <div className="col-lg-5" data-aos="fade-left" data-aos-delay="200">
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
                <button
                  className="btn oc-btn-white px-4 py-3 fw-bold text-uppercase"
                  onClick={() => navigate("/contact")}
                >
                  Get Free Consultation →
                </button>

                <a
                  className="btn oc-btn-ghost px-4 py-3 fw-bold text-uppercase"
                  href="tel:8428010909"
                >
                  📞 (+91) 8428010909
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
